function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 35.5C3 39.768 3.84064 43.9941 5.47391 47.9372C7.10719 51.8803 9.50112 55.4631 12.519 58.481C15.5369 61.4989 19.1197 63.8928 23.0628 65.5261C27.0059 67.1594 31.232 68 35.5 68C39.768 68 43.9941 67.1594 47.9372 65.5261C51.8803 63.8928 55.4631 61.4989 58.481 58.481C61.4989 55.4631 63.8928 51.8803 65.5261 47.9372C67.1594 43.9941 68 39.768 68 35.5C68 31.232 67.1594 27.0059 65.5261 23.0628C63.8928 19.1197 61.4989 15.5369 58.481 12.519C55.4631 9.50113 51.8803 7.10719 47.9372 5.47392C43.9941 3.84064 39.768 3 35.5 3C31.232 3 27.0059 3.84064 23.0628 5.47392C19.1197 7.10719 15.5369 9.50113 12.519 12.519C9.50112 15.5369 7.10719 19.1197 5.47391 23.0628C3.84064 27.0059 3 31.232 3 35.5Z",
  stroke: "white",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.4996 35.5001L28.2773 46.3335",
  stroke: "white",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5 17.4443V35.4999",
  stroke: "white",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgFastNegotiation = function SvgFastNegotiation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFastNegotiation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fast_negotiation.934ed031.svg";
export { ForwardRef as ReactComponent };